import Button from '../../../components/base/Button';

export default function PricingSection() {
  const inclusions = [
    'Struttura ad hoc per convertire',
    'Copy allineati alle campagne',
    'Landing responsive pronta all\'uso',
    'Design coerente con il tuo brand',
    'Integrazione elementi di contatto',
    'Tracciamento base conversioni',
    '2 revisioni incluse nel prezzo',
    'Consegna in 7 giorni lavorativi',
    'Opzioni chiare definite in call'
  ];

  const guarantees = [
    'Widget personalizzati, URL esatti, calcolatori e tool custom preventivati separatamente',
    '100% Soddisfatti o rimborsati',
    'Codice sorgente proprietario'
  ];

  const handleCallClick = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'clic_pulsante_chiamata'
      });
    }
  };

  return (
    <section id="pricing" className="py-16 md:py-24 lg:py-32 px-4 bg-white relative overflow-hidden">
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-12 md:mb-16 space-y-4 md:space-y-6">
          <div className="inline-block px-4 py-2 bg-white border-2 border-[#000000] text-[#000000] text-xs md:text-sm font-semibold whitespace-nowrap">
            QUANTO COSTA
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#000000]">
            Prezzo fisso. Tutto chiaro <br className="hidden md:block" />fin dalla prima call.
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
            Sai cosa è incluso, come funziona il pagamento e quali sono le opzioni disponibili.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-[#000000] text-white p-8 md:p-12 lg:p-16 relative">
            
            <div className="relative z-10">
              <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-8 md:mb-12">
                <div className="mb-6 md:mb-0">
                  <div className="text-xs md:text-sm text-gray-400 mb-2">Pacchetto completo</div>
                  <div className="flex items-baseline gap-2">
                    <span className="text-5xl md:text-6xl lg:text-7xl font-bold">€489</span>
                    <span className="text-base md:text-lg text-gray-400">invece di 750€</span>
                  </div>
                </div>
                
                <div className="w-full md:w-auto">
                  <button
                    onClick={handleCallClick}
                    data-cal-link="andrea-disanto-0kedbr/30min"
                    data-cal-namespace="30min"
                    data-cal-config='{"layout":"month_view"}'
                    className="w-full md:w-auto whitespace-nowrap font-medium transition-all duration-300 cursor-pointer border-2 bg-[#2563eb] text-white border-[#2563eb] hover:bg-[#1e40af] hover:border-[#1e40af] px-8 py-4 text-base md:text-lg md:px-10 md:py-5"
                  >
                    Prenota una call gratuita
                  </button>
                </div>
              </div>

              <div className="space-y-8 md:space-y-10">
                <div>
                  <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6">Cosa include:</h3>
                  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-12 md:mb-16 max-w-5xl mx-auto">
                    {inclusions.map((item, index) => (
                      <div key={index} className="flex items-start gap-3">
                        <i className="ri-check-line text-[#2563eb] text-lg md:text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-sm md:text-base text-gray-300">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="border-t border-gray-800 pt-6 md:pt-8">
                  <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6">Funzionalità Extra:</h3>
                  <div className="space-y-3 md:space-y-4">
                    <div className="flex items-start gap-3">
                      <span className="text-sm md:text-base text-gray-300">Widget personalizzati, URL esatti, calcolatori e tool custom preventivati separatamente</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
